






import { Component, Prop, Vue } from "vue-property-decorator";
import { ILocale } from "@/@types/locale";

interface ICat {
  _id: string;
  name: ILocale;
}

@Component({})
export default class StandartCategoryName extends Vue {
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;

  get category(): ICat | null {
    const category = this.categorys.find((c) => c._id == this.id);
    return category ? category : null;
  }

  get name(): string {
    if (!this.category) return "";
    return this.$getLocale(this.category.name);
  }
}
